import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { LocalStorageService } from './local-storage-service';

@Injectable({
  providedIn: 'root'
})
export class GenerateStaticDocumentSets {

  constructor(
    private _http: HttpClient,
    private _localStorageService: LocalStorageService
  ) { }

  private getDepartmentFromLocalStorage(): string {
    return this._localStorageService.getItem('selectedDepartment');
  }

  generateStaticDocs(clientId: string, answerSetId: string, values: any) {
    const department = this.getDepartmentFromLocalStorage();

    return this._http.post(`${environment.api}/api/v1/docbuilderanswersets/generatestaticdocs?department=${department}&clientId=${clientId}&answerSetId=${answerSetId}`, values);
  }
}
